module.exports = __webpack_public_path__ + "img/Position.c927208a.svg";